export enum UserRole {
  Agent = 'insAgent',
  Customer = 'insCustomer',
  Admin = 'insAdmin',
  SalesAdmin = 'insSalesAdmin',
  Underwriting = 'insUnderwriting',
}
